import { Component, OnInit } from '@angular/core'
import { SplashScreen } from '@ionic-native/splash-screen/ngx'
import { StatusBar } from '@ionic-native/status-bar/ngx'
import { Platform } from '@ionic/angular'
import { LoginService } from './login/login.service'
import { captureReturnTo } from './login/return-to'

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private loginService: LoginService
  ) {
    // Muss VOR dem Routing laufen: der Router leitet '' auf '/login' um und der
    // Auth0-Sprung kehrt ohne Suchparameter zurück (login/return-to.ts).
    captureReturnTo()
    this.initializeApp()
  }

  ngOnInit() {
    const authUserToken = this.loginService.getUser()

    if (authUserToken) {
      this.loginService.setUser(authUserToken)
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault()
      this.splashScreen.hide()
    })
  }
}
